import { useQuery } from "@tanstack/react-query";
import { Tabs, TabsProps } from "antd";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { getSalesReports } from "../../../network/Reports";
import { queryKeys } from "../../../services/react-query/queryKeys";
import HeaderTable from "../HeaderTable";
import GiftCards from "../tables/sales/GiftCards";
import Memberships from "../tables/sales/Memberships";
import SalesHistory from "../tables/sales/SalesHistory";
import LayoutReports from "./LayoutReports";

type Props = {};

const SalesReports = (props: Props) => {
  const intl = useIntl();
  const [key, setKey] = useState("");
  const [page, setPage] = useState(1);
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number } }) => state.calendar
  );
  const { data, isLoading } = useQuery([queryKeys?.reports, key, page], () =>
    getSalesReports(
      locationId,
      key === "salesHistory"
        ? {
            page,
          }
        : {
            type: key,
            page,
          }
    )
  );
  console.log(data);

  const tabs: TabsProps["items"] = [
    // {
    //   key: "summery-sales",
    //   label: (
    //     <div className="text-[#4f5062] w-full bg-white px-[10px] py-[10px] !rounded-[14%]">
    //       <FormattedMessage id="salesSummary" defaultMessage="ملخص المبيعات" />
    //     </div>
    //   ),
    //   children: (
    //     <SalesSummary
    //       data={data}
    //       setPage={setPage}
    //       page={page}
    //       isLoading={isLoading}
    //     />
    //   ),
    // },
    {
      key: "salesHistory",
      label: (
        <div className="text-[#4f5062] w-full bg-white px-[10px] py-[10px] !rounded-[14%]">
          <FormattedMessage id="salesHistory" defaultMessage="سجل المبيعات" />
        </div>
      ),
      children: (
        <SalesHistory
          data={data}
          setPage={setPage}
          page={page}
          isLoading={isLoading}
        />
      ),
    },
    {
      key: "gift-cards",
      label: (
        <div className="text-[#4f5062] w-full bg-white px-[10px] py-[10px] !rounded-[14%]">
          <FormattedMessage id="giftCards" defaultMessage="كروت الهدايا" />
        </div>
      ),
      children: (
        <GiftCards
          data={data}
          setPage={setPage}
          page={page}
          isLoading={isLoading}
        />
      ),
    },
    {
      key: "membership",
      label: (
        <div className="text-[#4f5062] w-full bg-white px-[10px] py-[10px] !rounded-[14%]">
          <FormattedMessage id="memberships" defaultMessage="العضويات" />
        </div>
      ),
      children: (
        <Memberships
          data={data?.data}
          setPage={setPage}
          page={page}
          isLoading={isLoading}
        />
      ),
    },
    // {
    //   key: "5",
    //   label: (
    //     <div className="text-[#4f5062] w-full bg-white px-[10px] py-[10px] !rounded-[14%]">
    //       <FormattedMessage
    //         id="discountsSummary"
    //         defaultMessage="ملخص الخصومات"
    //       />
    //     </div>
    //   ),
    //   children: (
    //     <SummaryOfDiscounts
    //       data={data}
    //       setPage={setPage}
    //       page={page}
    //       isLoading={isLoading}
    //     />
    //   ),
    // },
    // {
    //   key: "6",
    //   label: (
    //     <div className="text-[#4f5062] w-full bg-white px-[10px] py-[10px] !rounded-[14%]">
    //       <FormattedMessage id="taxSummary" defaultMessage="ملخص الضرائب" />
    //     </div>
    //   ),
    //   children: (
    //     <TaxSummary
    //       data={data}
    //       setPage={setPage}
    //       page={page}
    //       isLoading={isLoading}
    //     />
    //   ),
    // },
  ];
  const onChange = (key: string) => {
    setKey(key);
  };
  return (
    <LayoutReports>
      <HeaderTable data={data} />
      <div className="reportsChild">
        <Tabs
          defaultActiveKey="1"
          items={tabs}
          onChange={onChange}
          tabBarStyle={{ margin: 0 }}
        />
      </div>
    </LayoutReports>
  );
};

export default SalesReports;
